import IconCard from "../static/icon/IconCard";
import IconEvCharger from "../static/icon/IconEvCharger";
import IconBookingManagement from "../static/icon/IconBookingManagement";
import IconContactUs from "../static/icon/IconContactUs";
import IconLand from "../static/icon/IconLand";
import IconMaster from "../static/icon/IconMaster";
import IconMobile from "../static/icon/IconMobile";
import IconPayment from "../static/icon/IconPayment";
import IconPrice from "../static/icon/IconPrice";
import IconPrivacyPolicy from "../static/icon/IconPrivacyPolicy";
import IconReport from "../static/icon/IconReport";
import IconShop from "../static/icon/IconShop";
import IconTutorials from "../static/icon/IconTutorials";
import IconWebAdmin from "../static/icon/IconWebAmin";
import IconAdvertise from "../static/icon/IconAdvertise";

const menu = [
  {
    name: "Site",
    path: "/landlord",
    icon: <IconLand style={{ fontSize: 20 }} />,
    roles: ['admin', 'merchant', 'party', 'callcenter', 'station'],
  },
  {
    name: "Group",
    path: "/party",
    icon: <IconLand style={{ fontSize: 20 }} />,
    roles: ['admin'],
  },
  {
    name: "Cluster",
    path: "/merchant",
    icon: <IconShop style={{ fontSize: 20 }} />,
    roles: ['admin', 'callcenter'],
  },
  {
    name: "Devices",
    icon: <IconEvCharger style={{ fontSize: 20 }} />,
    roles: ['admin', 'merchant', 'party', 'landlord', 'callcenter', 'station'],
    submenu: [
      {
        name: "Charger",
        path: "/charger",
      },
      {
        name: "Charger Brand",
        path: "/charger-brand",
        roles: ['admin'],
      },
    ],
  },
  {
    name: "Price",
    path: "/price",
    icon: <IconPrice style={{ fontSize: 20 }} />,
    roles: ['admin', 'marketting'],
  },
  {
    name: "Private station",
    icon: <IconCard style={{ fontSize: 20 }} />,
    roles: ['admin', 'station'],
    submenu: [
      {
        name: "Member",
        path: "/user-promotion",
        roles: ['admin', 'station'],
      },
      {
        name: "Code",
        path: "/promotion/landlord",
        roles: ['admin', 'marketting'],
      },
    ],
  },
  {
    name: "Coupon&point Management",
    icon: <IconCard style={{ fontSize: 20 }} />,
    roles: ['admin', 'marketting'],
    submenu: [
      {
        name: "Promotion Code",
        path: "/promotion/discount",
      },
      {
        name: "Point Code",
        path: "/promotion/point",
      },
      {
        name: "Discount Report",
        path: "/user-promotion-report",
      },
    ],
  },
  {
    name: "Marketing",
    icon: <IconMaster style={{ fontSize: 20 }} />,
    roles: ['admin', 'marketting'],
    submenu: [
      {
        name: "Point Setup",
        path: "/point-setup",
      },
    ],
  },
  {
    name: "Web Admin User",
    path: "/web-admin",
    icon: <IconWebAdmin style={{ fontSize: 20 }} />,
    roles: ['admin'],
  },

  {
    name: "Member Mobile User",
    path: "/member-mobile-user",
    icon: <IconMobile style={{ fontSize: 20 }} />,
    roles: ['admin', 'callcenter'],
  },
  {
    name: "Transaction Management",
    path: "/charging-payment",
    icon: <IconPayment style={{ fontSize: 20 }} />,
    roles: ['admin'],
  },
  {
    name: "Booking Management",
    path: "/booking-management",
    icon: <IconBookingManagement style={{ fontSize: 20 }} />,
    roles: ['admin', 'callcenter', 'station'],
  },
  {
    name: "Booking Report",
    path: "/booking-report",
    icon: <IconReport style={{ fontSize: 20 }} />,
    roles: ['admin', 'merchant', 'party', 'landlord', 'callcenter', 'marketting', 'station'],
  },
  {
    name: "Tutorial Management",
    icon: <IconTutorials style={{ fontSize: 20 }} />,
    roles: ['admin', 'marketting'],
    submenu: [
      {
        name: "Create Tutorials ",
        path: "/guide",
      },
      {
        name: "Manage Tutorials ",
        path: "/guide-manage",
      },
    ],
  },
  {
    name: "Policy Management",
    icon: <IconPrivacyPolicy style={{ fontSize: 20 }} />,
    roles: ['admin', 'marketting'],
    submenu: [
      {
        name: "Term&Condition",
        path: "/term-condition",
      },
      {
        name: "Privacy Policy",
        path: "/privacy-policy",
      },
    ],
  },
  {
    name: "Popup Management",
    path: "/popup",
    icon: <IconAdvertise style={{ fontSize: 20 }} />,
    roles: ['admin', 'marketting'],
  },
  {
    name: "Contact Us",
    path: "/contact-us",
    icon: <IconContactUs style={{ fontSize: 20 }} />,
    roles: ['admin', 'marketting'],
  },
];

export default menu;
